/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
import * as $protobuf from "protobufjs/minimal";

// Common aliases
const $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
const $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

export const ValueData = $root.ValueData = (() => {

    /**
     * Properties of a ValueData.
     * @exports IValueData
     * @interface IValueData
     * @property {number|null} [id] ValueData id
     * @property {number|null} [value] ValueData value
     * @property {number|null} [rank] ValueData rank
     */

    /**
     * Constructs a new ValueData.
     * @exports ValueData
     * @classdesc Represents a ValueData.
     * @implements IValueData
     * @constructor
     * @param {IValueData=} [properties] Properties to set
     */
    function ValueData(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ValueData id.
     * @member {number} id
     * @memberof ValueData
     * @instance
     */
    ValueData.prototype.id = 0;

    /**
     * ValueData value.
     * @member {number} value
     * @memberof ValueData
     * @instance
     */
    ValueData.prototype.value = 0;

    /**
     * ValueData rank.
     * @member {number} rank
     * @memberof ValueData
     * @instance
     */
    ValueData.prototype.rank = 0;

    /**
     * Creates a new ValueData instance using the specified properties.
     * @function create
     * @memberof ValueData
     * @static
     * @param {IValueData=} [properties] Properties to set
     * @returns {ValueData} ValueData instance
     */
    ValueData.create = function create(properties) {
        return new ValueData(properties);
    };

    /**
     * Encodes the specified ValueData message. Does not implicitly {@link ValueData.verify|verify} messages.
     * @function encode
     * @memberof ValueData
     * @static
     * @param {IValueData} message ValueData message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ValueData.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.id);
        if (message.value != null && Object.hasOwnProperty.call(message, "value"))
            writer.uint32(/* id 2, wireType 1 =*/17).double(message.value);
        if (message.rank != null && Object.hasOwnProperty.call(message, "rank"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.rank);
        return writer;
    };

    /**
     * Encodes the specified ValueData message, length delimited. Does not implicitly {@link ValueData.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ValueData
     * @static
     * @param {IValueData} message ValueData message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ValueData.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ValueData message from the specified reader or buffer.
     * @function decode
     * @memberof ValueData
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ValueData} ValueData
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ValueData.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ValueData();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.id = reader.uint32();
                    break;
                }
            case 2: {
                    message.value = reader.double();
                    break;
                }
            case 3: {
                    message.rank = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ValueData message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ValueData
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ValueData} ValueData
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ValueData.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ValueData message.
     * @function verify
     * @memberof ValueData
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ValueData.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.id != null && message.hasOwnProperty("id"))
            if (!$util.isInteger(message.id))
                return "id: integer expected";
        if (message.value != null && message.hasOwnProperty("value"))
            if (typeof message.value !== "number")
                return "value: number expected";
        if (message.rank != null && message.hasOwnProperty("rank"))
            if (!$util.isInteger(message.rank))
                return "rank: integer expected";
        return null;
    };

    /**
     * Creates a ValueData message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ValueData
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ValueData} ValueData
     */
    ValueData.fromObject = function fromObject(object) {
        if (object instanceof $root.ValueData)
            return object;
        let message = new $root.ValueData();
        if (object.id != null)
            message.id = object.id >>> 0;
        if (object.value != null)
            message.value = Number(object.value);
        if (object.rank != null)
            message.rank = object.rank >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a ValueData message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ValueData
     * @static
     * @param {ValueData} message ValueData
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ValueData.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.id = 0;
            object.value = 0;
            object.rank = 0;
        }
        if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
        if (message.value != null && message.hasOwnProperty("value"))
            object.value = options.json && !isFinite(message.value) ? String(message.value) : message.value;
        if (message.rank != null && message.hasOwnProperty("rank"))
            object.rank = message.rank;
        return object;
    };

    /**
     * Converts this ValueData to JSON.
     * @function toJSON
     * @memberof ValueData
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ValueData.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ValueData
     * @function getTypeUrl
     * @memberof ValueData
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ValueData.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ValueData";
    };

    return ValueData;
})();

export const FrameData = $root.FrameData = (() => {

    /**
     * Properties of a FrameData.
     * @exports IFrameData
     * @interface IFrameData
     * @property {string|null} [date] FrameData date
     * @property {Array.<IValueData>|null} [values] FrameData values
     */

    /**
     * Constructs a new FrameData.
     * @exports FrameData
     * @classdesc Represents a FrameData.
     * @implements IFrameData
     * @constructor
     * @param {IFrameData=} [properties] Properties to set
     */
    function FrameData(properties) {
        this.values = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * FrameData date.
     * @member {string} date
     * @memberof FrameData
     * @instance
     */
    FrameData.prototype.date = "";

    /**
     * FrameData values.
     * @member {Array.<IValueData>} values
     * @memberof FrameData
     * @instance
     */
    FrameData.prototype.values = $util.emptyArray;

    /**
     * Creates a new FrameData instance using the specified properties.
     * @function create
     * @memberof FrameData
     * @static
     * @param {IFrameData=} [properties] Properties to set
     * @returns {FrameData} FrameData instance
     */
    FrameData.create = function create(properties) {
        return new FrameData(properties);
    };

    /**
     * Encodes the specified FrameData message. Does not implicitly {@link FrameData.verify|verify} messages.
     * @function encode
     * @memberof FrameData
     * @static
     * @param {IFrameData} message FrameData message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FrameData.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.date != null && Object.hasOwnProperty.call(message, "date"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.date);
        if (message.values != null && message.values.length)
            for (let i = 0; i < message.values.length; ++i)
                $root.ValueData.encode(message.values[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified FrameData message, length delimited. Does not implicitly {@link FrameData.verify|verify} messages.
     * @function encodeDelimited
     * @memberof FrameData
     * @static
     * @param {IFrameData} message FrameData message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FrameData.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a FrameData message from the specified reader or buffer.
     * @function decode
     * @memberof FrameData
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {FrameData} FrameData
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FrameData.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.FrameData();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.date = reader.string();
                    break;
                }
            case 2: {
                    if (!(message.values && message.values.length))
                        message.values = [];
                    message.values.push($root.ValueData.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a FrameData message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof FrameData
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {FrameData} FrameData
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FrameData.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a FrameData message.
     * @function verify
     * @memberof FrameData
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    FrameData.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.date != null && message.hasOwnProperty("date"))
            if (!$util.isString(message.date))
                return "date: string expected";
        if (message.values != null && message.hasOwnProperty("values")) {
            if (!Array.isArray(message.values))
                return "values: array expected";
            for (let i = 0; i < message.values.length; ++i) {
                let error = $root.ValueData.verify(message.values[i]);
                if (error)
                    return "values." + error;
            }
        }
        return null;
    };

    /**
     * Creates a FrameData message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof FrameData
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {FrameData} FrameData
     */
    FrameData.fromObject = function fromObject(object) {
        if (object instanceof $root.FrameData)
            return object;
        let message = new $root.FrameData();
        if (object.date != null)
            message.date = String(object.date);
        if (object.values) {
            if (!Array.isArray(object.values))
                throw TypeError(".FrameData.values: array expected");
            message.values = [];
            for (let i = 0; i < object.values.length; ++i) {
                if (typeof object.values[i] !== "object")
                    throw TypeError(".FrameData.values: object expected");
                message.values[i] = $root.ValueData.fromObject(object.values[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a FrameData message. Also converts values to other types if specified.
     * @function toObject
     * @memberof FrameData
     * @static
     * @param {FrameData} message FrameData
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    FrameData.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.values = [];
        if (options.defaults)
            object.date = "";
        if (message.date != null && message.hasOwnProperty("date"))
            object.date = message.date;
        if (message.values && message.values.length) {
            object.values = [];
            for (let j = 0; j < message.values.length; ++j)
                object.values[j] = $root.ValueData.toObject(message.values[j], options);
        }
        return object;
    };

    /**
     * Converts this FrameData to JSON.
     * @function toJSON
     * @memberof FrameData
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    FrameData.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for FrameData
     * @function getTypeUrl
     * @memberof FrameData
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    FrameData.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/FrameData";
    };

    return FrameData;
})();

export const DataSet = $root.DataSet = (() => {

    /**
     * Properties of a DataSet.
     * @exports IDataSet
     * @interface IDataSet
     * @property {Array.<IFrameData>|null} [frames] DataSet frames
     */

    /**
     * Constructs a new DataSet.
     * @exports DataSet
     * @classdesc Represents a DataSet.
     * @implements IDataSet
     * @constructor
     * @param {IDataSet=} [properties] Properties to set
     */
    function DataSet(properties) {
        this.frames = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * DataSet frames.
     * @member {Array.<IFrameData>} frames
     * @memberof DataSet
     * @instance
     */
    DataSet.prototype.frames = $util.emptyArray;

    /**
     * Creates a new DataSet instance using the specified properties.
     * @function create
     * @memberof DataSet
     * @static
     * @param {IDataSet=} [properties] Properties to set
     * @returns {DataSet} DataSet instance
     */
    DataSet.create = function create(properties) {
        return new DataSet(properties);
    };

    /**
     * Encodes the specified DataSet message. Does not implicitly {@link DataSet.verify|verify} messages.
     * @function encode
     * @memberof DataSet
     * @static
     * @param {IDataSet} message DataSet message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DataSet.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.frames != null && message.frames.length)
            for (let i = 0; i < message.frames.length; ++i)
                $root.FrameData.encode(message.frames[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified DataSet message, length delimited. Does not implicitly {@link DataSet.verify|verify} messages.
     * @function encodeDelimited
     * @memberof DataSet
     * @static
     * @param {IDataSet} message DataSet message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DataSet.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a DataSet message from the specified reader or buffer.
     * @function decode
     * @memberof DataSet
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {DataSet} DataSet
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DataSet.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.DataSet();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    if (!(message.frames && message.frames.length))
                        message.frames = [];
                    message.frames.push($root.FrameData.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a DataSet message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof DataSet
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {DataSet} DataSet
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DataSet.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a DataSet message.
     * @function verify
     * @memberof DataSet
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    DataSet.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.frames != null && message.hasOwnProperty("frames")) {
            if (!Array.isArray(message.frames))
                return "frames: array expected";
            for (let i = 0; i < message.frames.length; ++i) {
                let error = $root.FrameData.verify(message.frames[i]);
                if (error)
                    return "frames." + error;
            }
        }
        return null;
    };

    /**
     * Creates a DataSet message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof DataSet
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {DataSet} DataSet
     */
    DataSet.fromObject = function fromObject(object) {
        if (object instanceof $root.DataSet)
            return object;
        let message = new $root.DataSet();
        if (object.frames) {
            if (!Array.isArray(object.frames))
                throw TypeError(".DataSet.frames: array expected");
            message.frames = [];
            for (let i = 0; i < object.frames.length; ++i) {
                if (typeof object.frames[i] !== "object")
                    throw TypeError(".DataSet.frames: object expected");
                message.frames[i] = $root.FrameData.fromObject(object.frames[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a DataSet message. Also converts values to other types if specified.
     * @function toObject
     * @memberof DataSet
     * @static
     * @param {DataSet} message DataSet
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    DataSet.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.frames = [];
        if (message.frames && message.frames.length) {
            object.frames = [];
            for (let j = 0; j < message.frames.length; ++j)
                object.frames[j] = $root.FrameData.toObject(message.frames[j], options);
        }
        return object;
    };

    /**
     * Converts this DataSet to JSON.
     * @function toJSON
     * @memberof DataSet
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    DataSet.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for DataSet
     * @function getTypeUrl
     * @memberof DataSet
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    DataSet.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/DataSet";
    };

    return DataSet;
})();

export { $root as default };
